import { styled } from '../muiReexports';
import { SvgIcon } from '../SvgIcon';
export const ColorSquareIconStyled = styled(SvgIcon)({
    '> path': {
        opacity: '1 !important',
    },
});
